<template>
  <div>
    <shell>
      <div class="container m-auto">
        <div class="sm:w-full lg:w-1/2 pb-6 m-auto px-2">
          <div v-if="isEmailVerified">
            <h2 class="text-3xl font-bold pb-12">Your Email is Verified</h2>
            <p v-if="isPaidCustomer" class="leading-normal mb-4 text-base">Go to your <router-link to="/">notes</router-link>.</p>
            <p v-else class="leading-normal mb-4 text-base"><router-link to="/">Get started!</router-link>.</p>
          </div>
          <div v-else>
            <h2 class="text-3xl font-bold pb-12">Almost done.</h2>

            <p class="leading-normal mb-4 text-base">Please check your email for a verification message from /tap.</p>
            <p class="leading-normal mb-4 text-xs">
              <span v-if="isFirstAttempt">Didn&rsquo;t receive an email at {{member.email}}? <span class="cursor-pointer text-underline text-full-blue" @click="resend">Resend verification email</span></span>
              <span v-else>We sent another verification email. If the problem persists, please contact <a href="mailto:hello@tatatap.com">support</a></span>.</p>
          </div>
        </div>
      </div>
    </shell>
  </div>
</template>

<script>
 import {mapState, mapGetters} from 'vuex';
 import api from '@/api';

 import Shell from '@/components/Shell';

 export default {
   data () {
     return {
       isFirstAttempt: true
     }
   },

   components: {Shell},

   computed: {
     ...mapGetters(['isPaidCustomer']),

     ...mapState({
       member: state => state.member
     }),

     isEmailVerified () {
       return this.member.email_verified;
     }
   },

   methods: {
     async resend() {
       this.isFirstAttempt = false
       await api.resendMemberEmailVerification();
     }
   }
 };
</script>
